import { render, staticRenderFns } from "./CardCalendario.vue?vue&type=template&id=bb8afc54&"
import script from "./CardCalendario.vue?vue&type=script&lang=js&"
export * from "./CardCalendario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports